var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7656 27.5426H23.0244V20.1147C23.0244 18.3436 22.9924 16.0631 20.558 16.0631C18.0886 16.0631 17.7105 17.9925 17.7105 19.9845V27.5419H12.9693V12.2712H17.5208V14.3583H17.5822C18.0378 13.5794 18.6961 12.9386 19.487 12.5043C20.2779 12.0699 21.1718 11.8582 22.0735 11.8918C26.8792 11.8918 27.7656 15.0532 27.7656 19.1656V27.5426ZM7.61916 10.1834C7.07488 10.1835 6.54279 10.0222 6.09018 9.71986C5.63757 9.41754 5.28478 8.98777 5.07641 8.48492C4.86804 7.98207 4.81345 7.42871 4.91956 6.89483C5.02567 6.36096 5.2877 5.87054 5.67252 5.4856C6.05734 5.10066 6.54766 4.8385 7.08147 4.73226C7.61528 4.62603 8.16861 4.68049 8.67147 4.88877C9.17432 5.09704 9.60413 5.44977 9.90653 5.90235C10.2089 6.35493 10.3703 6.88703 10.3703 7.43135C10.3703 8.16112 10.0805 8.86101 9.56457 9.3771C9.04864 9.89318 8.34887 10.1832 7.61916 10.1834ZM9.98976 27.5419H5.24365V12.2712H9.99037L9.98976 27.5419ZM30.127 0.276616H2.86078C2.55405 0.272888 2.2496 0.329701 1.96485 0.443804C1.68011 0.557908 1.42067 0.72706 1.20138 0.941575C0.982093 1.15609 0.807269 1.41176 0.686916 1.69393C0.566563 1.97611 0.503045 2.27926 0.5 2.58602V29.9649C0.507286 30.5842 0.760077 31.1753 1.20284 31.6083C1.64561 32.0413 2.24214 32.2809 2.86139 32.2743H30.127C30.7478 32.2827 31.3466 32.0441 31.7916 31.611C32.2366 31.1779 32.4914 30.5858 32.5 29.9649V2.58111C32.4911 1.96056 32.2361 1.36896 31.7911 0.936446C31.346 0.503928 30.7474 0.26592 30.127 0.274775",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42e5e1b1391c3372ca27c59586b32722.svg";
export { ForwardRef as ReactComponent };